import { FirebaseActionTypes, FirebaseActions } from '@web_opxp/features';
import { EFeedbackType } from './types';

export const trackFeedbackResponse: (rating: EFeedbackType) => FirebaseActionTypes.IAnalyticsEventAction = (rating) => {
  let response: string;

  if (rating === EFeedbackType.later) {
    response = 'postponed';
  } else if (rating === EFeedbackType.negative) {
    response = 'contact form';
  } else {
    response = 'Trustpilot';
  }

  return FirebaseActions.analyticsEventAction({
    eventName: 'feedback_form',
    parameters: [
      {
        key: response,
        value: response,
      },
    ],
  });
};
